import { Component, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { IAppMenu } from '../../store';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  // @Select(s => s.appState.ui.menu) menu$: Observable<IAppMenu[]>;

  menu$$: IAppMenu[] = null;

  constructor(
    private store: Store
  ) {

    this.store.select(s => s.appState.ui.menu).subscribe((menu) => {
      if (menu) {
        this.menu$$ = menu;
      }
    });
  }

  ngOnInit(): void {
    // this.menu = [
    //   { label: 'Inicio', icon: 'home', route: '/' },
    //   {
    //     label: 'Solicitudes',
    //     icon: 'folder',
    //     route: '/administracion/periodo-lectivo'
    //     // children: [
    //     //   // { label: 'Periodo lectivo', route: '/administracion/periodo-lectivo' },
    //     // ]
    //   },
    //   {
    //     label: 'Plan Territorial',
    //     icon: 'track_changes',
    //     route: '/administracion/periodo-lectivo'
    //     // children: [
    //     //   // { label: 'Información general', route: '/institucion/informacion-general' },
    //     // ]
    //   },
    //   {
    //     label: 'Maestros',
    //     icon: 'view_module',
    //     route: '/maestros'
    //     // children: [
    //     //   // { label: 'Información general', route: '/institucion/informacion-general' },
    //     // ]
    //   },
    // ];
  }

}
